import Dropzone from "../../components/Dropzone";
const NewVarianttab = ({ product, updateVariant }) => {
  return <Dropzone product={product} updateVariant={updateVariant} />;
};
export default NewVarianttab;
